
define("rv!templates/about/partials/signup",[],function(){return { v:3,
  t:[ { t:7,
      e:"div",
      a:{ id:"enrollmentForm" },
      f:[ { t:7,
          e:"div",
          a:{ id:"formAndBranding" },
          f:[ { t:7,
              e:"div",
              a:{ id:"form" },
              f:[ { t:7,
                  e:"input",
                  a:{ id:"firstName",
                    type:"text",
                    "class":"short",
                    style:"margin-right: 5px;",
                    placeholder:"first" } },
                " ",
                { t:7,
                  e:"input",
                  a:{ id:"lastName",
                    type:"text",
                    "class":"short",
                    placeholder:"last" } },
                " ",
                { t:7,
                  e:"br",
                  a:{ "class":"clear" } },
                " ",
                { t:7,
                  e:"input",
                  a:{ id:"email",
                    type:"text",
                    placeholder:"email" } },
                { t:7,
                  e:"br" },
                " ",
                { t:7,
                  e:"input",
                  a:{ id:"employer",
                    type:"text",
                    placeholder:"Adestinn provider",
                    value:[ { t:4,
                        f:[ { t:2,
                            r:"customer.Name_Full" } ],
                        n:50,
                        x:{ r:[ "customer" ],
                          s:"_0!=null" } } ] },
                  m:[ { t:4,
                      f:[ "disabled=\"disabled\"" ],
                      n:50,
                      x:{ r:[ "customer" ],
                        s:"_0!=null" } } ] },
                " ",
                { t:4,
                  f:[ { t:7,
                      e:"a",
                      a:{ tabindex:"-1",
                        "class":"sideNote",
                        style:"margin-bottom: 5px; margin-top: -4px; display: block;",
                        href:"#",
                        id:"ltr_Employee" },
                      v:{ click:"clearEmployer" },
                      f:[ { t:7,
                          e:"div",
                          a:{ style:"text-align:center;" },
                          f:[ "At a different provider?" ] } ] } ],
                  n:50,
                  x:{ r:[ "customer" ],
                    s:"_0!=null" } },
                " ",
                { t:7,
                  e:"input",
                  a:{ type:"button",
                    id:"btnGetStarted",
                    "class":"btn btn-primary btn-large",
                    value:"Get Started",
                    style:"font-weight: bold;" } } ] },
            " ",
            { t:7,
              e:"div",
              a:{ id:"formInfo" },
              f:[ { t:7,
                  e:"div",
                  a:{ ID:"noBranding" },
                  f:[ { t:4,
                      f:[ { t:8,
                          r:"CustomerImage" } ],
                      n:50,
                      x:{ r:[ "isNullOrWhiteSpace",
                          "overrideText" ],
                        s:"_0(_1)" } },
                    " ",
                    { t:7,
                      e:"div",
                      a:{ id:"customerTopText" },
                      f:[ { t:4,
                          f:[ { t:3,
                              r:"overrideText" } ],
                          n:50,
                          x:{ r:[ "isNullOrWhiteSpace",
                              "overrideText" ],
                            s:"!_0(_1)" } },
                        { t:4,
                          n:51,
                          f:[ { t:4,
                              n:50,
                              x:{ r:[ "customer",
                                  "isNullOrWhiteSpace",
                                  "customer.TopText" ],
                                s:"_0!=null&&!_1(_2)" },
                              f:[ { t:3,
                                  r:"customer.TopText" } ] },
                            { t:4,
                              n:50,
                              x:{ r:[ "customer",
                                  "isNullOrWhiteSpace",
                                  "customer.TopText" ],
                                s:"!(_0!=null&&!_1(_2))" },
                              f:[ " ",
                                { t:7,
                                  e:"strong",
                                  a:{ style:"font-size: 13px;" },
                                  f:[ { t:4,
                                      f:[ "Vacation Savings with ",
                                        { t:4,
                                          f:[ "up to a 50%" ],
                                          n:50,
                                          x:{ r:[ "Settings.MatchPercentage" ],
                                            s:"_0===\"Default\"" } },
                                        { t:4,
                                          n:51,
                                          f:[ "a ",
                                            { t:2,
                                              r:"Settings.MatchPercentage" } ],
                                          x:{ r:[ "Settings.MatchPercentage" ],
                                            s:"_0===\"Default\"" } },
                                        " Match" ],
                                      n:50,
                                      x:{ r:[ "customer" ],
                                        s:"_0==null" } },
                                    { t:4,
                                      n:51,
                                      f:[ "Meet Adestinn:",
                                        { t:7,
                                          e:"br" },
                                        " ",
                                        { t:7,
                                          e:"span",
                                          a:{ style:"text-decoration: underline;" },
                                          f:[ "Your new vacation savings match benefit." ] } ],
                                      x:{ r:[ "customer" ],
                                        s:"_0==null" } } ] },
                                " ",
                                { t:7,
                                  e:"div",
                                  f:[ { t:4,
                                      f:[ "Opening your Vacations Savings Account is fast, easy, and free. Your savings will add up fast, and you can relax knowing your hotel will be paid before you arrive.",
                                        { t:7,
                                          e:"br" },
                                        "Enroll now." ],
                                      n:50,
                                      x:{ r:[ "customer" ],
                                        s:"_0==null" } },
                                    { t:4,
                                      n:51,
                                      f:[ "We care about your health and wellbeing so we've put together a vacation wellness program for you. Adestinn’s ",
                                        { t:4,
                                          f:[ "up to 50%" ],
                                          n:50,
                                          x:{ r:[ "Settings.MatchPercentage" ],
                                            s:"_0===\"Default\"" } },
                                        { t:4,
                                          n:51,
                                          f:[ { t:2,
                                              r:"Settings.MatchPercentage" } ],
                                          x:{ r:[ "Settings.MatchPercentage" ],
                                            s:"_0===\"Default\"" } },
                                        " Vacation Savings Match Program is already being used by thousands of employees." ],
                                      x:{ r:[ "customer" ],
                                        s:"_0==null" } } ] } ] } ],
                          x:{ r:[ "isNullOrWhiteSpace",
                              "overrideText" ],
                            s:"!_0(_1)" } } ] } ] } ] } ] },
        " ",
        { t:7,
          e:"div",
          a:{ id:"afterSuccess",
            style:"display: none;" },
          f:[ { t:8,
              r:"CustomerImage" },
            " Hey, ",
            { t:7,
              e:"span",
              a:{ "class":"memberFN" } },
            "! ",
            { t:7,
              e:"div",
              a:{ style:"margin-top: 8px;" } },
            " ",
            { t:7,
              e:"div",
              a:{ id:"memberBeingReviewed",
                "class":"initiallyHidden" },
              f:[ "Your information is being reviewed. We'll get back to you soon!" ] },
            " ",
            { t:7,
              e:"div",
              a:{ id:"NotActivated",
                "class":"initiallyHidden" },
              f:[ { t:7,
                  e:"div",
                  a:{ style:"margin-bottom: 8px;" } },
                " To complete your membership, choose a password for your Adestinn account. ",
                { t:7,
                  e:"div",
                  a:{ style:"margin-bottom: 8px;" } },
                " ",
                { t:7,
                  e:"a",
                  a:{ "class":"activationLink btn btn-warning" },
                  f:[ "Continue Registration" ] },
                " ",
                { t:7,
                  e:"div",
                  a:{ style:"margin-top: 8px;" } } ] },
            " ",
            { t:7,
              e:"div",
              a:{ id:"Activated",
                "class":"initiallyHidden" },
              f:[ { t:7,
                  e:"strong",
                  f:[ "Book now, pay later" ] },
                "—browse destinations to find your dream vacation. By using your future savings, youʼll have the hotel paid before you arrive. ",
                { t:7,
                  e:"br" },
                { t:7,
                  e:"br" },
                " ",
                { t:7,
                  e:"div",
                  f:[ { t:7,
                      e:"a",
                      a:{ "class":"btn btn-primary",
                        href:"/#/destinations" },
                      f:[ "Browse Destinatons" ] } ] },
                " ",
                { t:7,
                  e:"div",
                  a:{ style:"margin-top: 8px;" } } ] },
            " ",
            { t:7,
              e:"div",
              a:{ id:"NotLinked",
                "class":"initiallyHidden" },
              f:[ { t:7,
                  e:"a",
                  a:{ href:"/myaccount/financialaccount.aspx" },
                  f:[ "Link your bank account" ] },
                " to start saving now." ] },
            " ",
            { t:7,
              e:"div",
              a:{ style:"margin-top: 5px;" },
              f:[ { t:7,
                  e:"a",
                  a:{ href:"#",
                    style:"font-size: 10px;",
                    "class":"clearSetMember",
                    "data-clear":"true" },
                  f:[ "Not ",
                    { t:7,
                      e:"span",
                      a:{ "class":"memberFN" } },
                    "?" ] } ] } ] } ] },
    " ",
    { t:7,
      e:"a",
      a:{ id:"hiddenAnchor",
        "class":"infoLink",
        style:"display:none;",
        href:"#MemberShipRequestResults" } },
    " ",
    { t:7,
      e:"div",
      a:{ id:"MemberShipRequestResults" } } ],
  p:{ CustomerImage:[ { t:4,
        f:[ { t:7,
            e:"img",
            a:{ id:"customerImage",
              alt:[ { t:2,
                  r:"customer.Name_Full" } ],
              src:[ { t:2,
                  r:"customer.ImageSrc" } ],
              style:[ "height:",
                { t:2,
                  r:"customer.ImgHeight" },
                ";width:",
                { t:2,
                  r:"customer.ImgWidth" },
                ";float:right;" ] } } ],
        n:50,
        x:{ r:[ "customer",
            "isNullOrWhiteSpace",
            "customer.ImageSrc" ],
          s:"_0!=null&&!_1(_2)" } } ] } };});
